import { configureStore } from "@reduxjs/toolkit";
import reviewReducer from "./reviewReducer";
import loginReducer from "./loginReducer";
import questionCardReducer from "./questionCardReducer";
import interviewConfigReducer from "./interviewConfigReducer";
import studentPageReducer from "./studentPageReducer";
import reportReducer from "./reportReducer";
import studentManagementReducer from "./studentManagementReducer";
import schedulingReducer from "./schedulingReducer";

export default configureStore({
  reducer: {
    review: reviewReducer,
    login: loginReducer,
    note: questionCardReducer,
    interviewconfig: interviewConfigReducer,
    studentpage: studentPageReducer,
    report: reportReducer,
    studentManagement: studentManagementReducer,
    scheduling: schedulingReducer,
  },
});
